import { render, staticRenderFns } from "./gytlgz.vue?vue&type=template&id=a282951c&scoped=true"
import script from "./gytlgz.vue?vue&type=script&lang=js"
export * from "./gytlgz.vue?vue&type=script&lang=js"
import style0 from "./gytlgz.vue?vue&type=style&index=0&id=a282951c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a282951c",
  null
  
)

export default component.exports